import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, WrenchIcon, ShieldCheckIcon } from 'lucide-react';
export function WhyHubble() {
  const cards = [{
    icon: TrendingUpIcon,
    label: 'Increase Revenue',
    headline: 'Go to market faster',
    body: 'Ship agents already integrated into the systems they need, EHRs, payers, and pharmacy networks, so you launch revenue-generating workflows sooner.'
  }, {
    icon: WrenchIcon,
    label: 'Reduce Cost',
    headline: 'Stop building plumbing',
    body: 'No engineering time spent on building and maintaining integrations. Your team stays focused on your product, not on data infrastructure.'
  }, {
    icon: ShieldCheckIcon,
    label: 'Reduce Risk',
    headline: 'Built-in audit trails',
    body: 'Every agent action is permissioned, logged, and HIPAA-compliant from day one, giving compliance teams the audit trail they need without extra work.'
  }];
  return <section id="why-hubble" className="py-24 bg-hubble-card/30 relative z-10 border-y border-hubble-border/50" data-id="element-231">
      <div className="max-w-7xl mx-auto px-6" data-id="element-232">
        <div className="text-center mb-16" data-id="element-233">
          <span className="text-hubble-signal text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-234">
            WHY HUBBLE
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-paper" data-id="element-235">
            Why teams build on Hubble.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-236">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-signal/30 transition-colors group relative overflow-hidden" data-id="element-237">
              <div className="absolute inset-0 bg-gradient-to-br from-hubble-signal/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-238"></div>

              <div className="relative z-10" data-id="element-239">
                <div className="w-12 h-12 rounded-xl bg-hubble-signal/10 border border-hubble-signal/20 flex items-center justify-center mb-6" data-id="element-240">
                  <card.icon className="w-6 h-6 text-hubble-signal" data-id="element-241" />
                </div>
                <p className="font-body text-sm font-medium text-hubble-signal uppercase tracking-[2px] mb-3" data-id="element-242">
                  {card.label}
                </p>
                <h3 className="font-heading text-2xl md:text-[28px] font-normal text-hubble-paper mb-3 leading-tight" data-id="element-243">
                  {card.headline}
                </h3>
                <p className="font-body text-[16px] text-hubble-paper/70 leading-[1.6]" data-id="element-244">
                  {card.body}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}